import {getConfig} from 'config';
import {getData, putData, postData} from '../dataProvider';

export const loadRecommendations = () => {
  return getData(`${getConfig('recommendationsUrl')}`);
};
export const feedbackSettings = () => {
  return getData(`${getConfig('feedbackSettingsUrl')}`);
};
export const saveFeedbackSettings = optedOut => {
  return putData(`${getConfig('feedbackSettingsUrl')}`, {opted_out: optedOut}, {});
};
export const saveRecommendationFeedback = (declarationId, rating, reasonCode, comment) => {
  const data = { declaration_id: declarationId, rating };
  if (reasonCode !== undefined) data.reason_code = reasonCode;
  if (comment !== undefined) data.comment = comment;
  return postData(`${getConfig('recommendationFeedbackUrl')}`, data, { responseType: 'json' });
};
